/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_EmailInputs */

const en_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const es_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const zh_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const ar_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const fr_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const vi_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const sw_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barua pepe`)
};

const th_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const bs_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ja_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子メール`)
};

const ko_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일`)
};

const pt_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const it_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const sv_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

const nl_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const da_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const nb_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

const fi_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti`)
};

const pl_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const ru_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

const tr_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const hi_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल`)
};

const id_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surel`)
};

const ms_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mel`)
};

const cs_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const el_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const he_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דואר אלקטרוני`)
};

const af_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pos`)
};

const hu_contact_email = /** @type {(inputs: Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Contact_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_email = /** @type {((inputs?: Contact_EmailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_EmailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_email(inputs)
	if (locale === "de") return de_contact_email(inputs)
	if (locale === "zh") return zh_contact_email(inputs)
	if (locale === "ar") return ar_contact_email(inputs)
	if (locale === "fr") return fr_contact_email(inputs)
	if (locale === "vi") return vi_contact_email(inputs)
	if (locale === "sw") return sw_contact_email(inputs)
	if (locale === "th") return th_contact_email(inputs)
	if (locale === "bs") return bs_contact_email(inputs)
	if (locale === "ja") return ja_contact_email(inputs)
	if (locale === "ko") return ko_contact_email(inputs)
	if (locale === "pt") return pt_contact_email(inputs)
	if (locale === "it") return it_contact_email(inputs)
	if (locale === "sv") return sv_contact_email(inputs)
	if (locale === "nl") return nl_contact_email(inputs)
	if (locale === "da") return da_contact_email(inputs)
	if (locale === "nb") return nb_contact_email(inputs)
	if (locale === "fi") return fi_contact_email(inputs)
	if (locale === "pl") return pl_contact_email(inputs)
	if (locale === "ru") return ru_contact_email(inputs)
	if (locale === "tr") return tr_contact_email(inputs)
	if (locale === "hi") return hi_contact_email(inputs)
	if (locale === "id") return id_contact_email(inputs)
	if (locale === "ms") return ms_contact_email(inputs)
	if (locale === "cs") return cs_contact_email(inputs)
	if (locale === "el") return el_contact_email(inputs)
	if (locale === "he") return he_contact_email(inputs)
	if (locale === "af") return af_contact_email(inputs)
	if (locale === "hu") return hu_contact_email(inputs)
	return en_contact_email(inputs)
});